<template>
  <v-theme-provider
    class="grey lighten-4">
    <base-section
      id="com-syariah"
      space="40"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <base-section-heading title="Dewan Pengawas Syariah" />
            <base-body space="0">
               <v-container fluid>
                <v-row dense>
                  <v-col
                    v-for="card in cards"
                    :key="card.name"
                    md="4"
                    xs="12"
                  >
                    <div 
                      data-aos="zoom-in"
                      data-aos-delay="50"
                      data-aos-duration="1000"
                      data-aos-easing="ease-in-out"
                      data-aos-mirror="true"
                      data-aos-once="true"
                      data-aos-anchor-placement="top-center">
                      <v-hover v-slot="{ hover }">
                        <v-card
                        :elevation="hover ? 20 : 0"
                        :class="{ 'on-hover': hover }"
                        outlined>
                          <v-img
                            :src="require(`@/assets/${card.src}`)"
                            class="white--text align-end"
                            height="320px"
                            :gradient="hover ? '' : 'to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)'"
                            :alt="card.name"
                          >
                          <v-card-title class="body-1" v-text="card.name" v-if="hover===false"></v-card-title>
                          </v-img>
                          <v-card-actions>
                          <div  v-if="hover" class="caption" v-html="card.detail"></div>
                          <div v-else>{{ card.title }}</div>
                        </v-card-actions>
                        </v-card>
                      </v-hover>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </base-body>
          </v-col>
        </v-row>
      </v-container>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionComSyariah',
    data: () => ({
            posts: [],
            cards: [
              { name: 'Anwar Abbas', title: 'Ketua Dewan Pengawas Syariah', src: 'AnwarAbbas-nologo.png',detail:'<strong>DR. H. Anwar Abbas, M.M., M.Ag.</strong> Lahir di Balaimansiro, 15 Februari 1955. Beliau meraih gelar Doktor di bidang Pemikiran Islam dari UIN Syarif Hidayatullah Jakarta dan aktif sebagai Wakil Ketua Umum Majelis Ulama Indonesia (MUI) periode 2020–2025. Saat ini Beliau menjabat sebagai Ketua Dewan Pengawas Syariah PT Asuransi Takaful Umum sejak tahun 2014' },
              { name: 'Amin Musa', title: 'Anggota Dewan Pengawas Syariah', src: 'AminMusa-nologo.png',detail:'<strong>Amin Musa, S.E., QRMA.</strong> Lahir di Pemalang, 19 April 1963. Menjabat sebagai anggota Dewan Pengawas Syariah PT Asuransi Takaful Umum sejak tahun 2022. Beliau meraih gelar S1 di bidang Akuntansi dari STIE Indonesia' },
            ],
        }),
  }
</script>
